<template>
  <v-container pa-0>
    <v-row>
      <v-col><h2>{{title}}</h2></v-col>
      <v-col v-if="refresh" align="right">
        <v-btn
          text
          icon
          color="fanhiveHoney"
          @click="refreshClick"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
  
</template>

<script>
  export default {
    name: 'PageHeader',
    props: ['title','refresh'],
    methods: {
      refreshClick: function () {
        this.$parent.refresh();
      }
    }
  }
</script>
